import React from 'react'
import styled from 'styled-components'

const Separator = (props) => {

    const {nextColor,jumbo, oldColor} = props

    const BottomBeaty = styled.div`
        overflow:hidden;
        background-color: ${oldColor};
        background-image: ${jumbo === true ? "url('https://media1.giphy.com/media/jaOXKCxtBPLieRLI0c/giphy.gif')" : null};
        background-attachment: fixed;
        background-size: cover;
        background-position: center;
    `

    const Tampao = styled.div`
        background: ${nextColor};
        height: 120px;
        width: 100%;
        transform: skew(0deg,3deg);
        top: 53px;
        position: relative;
    `

    return (
        <>
            <BottomBeaty style={{overflow: 'hidden'}}>
                <Tampao />
            </BottomBeaty>
        </>
    )
}

export default Separator